import { useEffect, useState } from 'react';

import { getInjector } from '@/services/angularjs-bridge';

const useAdditionalCategoryAttributeService = () => {
    // eslint-disable-next-line
    const [additionalCategoryAttributeService, setAdditionalCategoryAttributeService] = useState<any>();
    useEffect(() => {
        const angularJSInjector = getInjector();
        const _additionalCategoryAttributeService = angularJSInjector.get('AdditionalCategoryAttributeService');
        setAdditionalCategoryAttributeService({..._additionalCategoryAttributeService});
    }, []);

    return { additionalCategoryAttributeService };
};
export default useAdditionalCategoryAttributeService;
